import React, { useEffect } from 'react';
import { Form, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import MapPinIcon from '../../../assets/icons/alert-plus/map-pin.svg';
import DismissAlertIcon from '../../../assets/icons/alert-plus/x.svg';
import './SiteCard.css';
import API from '../../../utils/API';

const SiteCard = ({ site, alertTemplates, refreshData, setSuccess, setError }) => {
  const navigate = useNavigate();

  const siteAlertInProgress = alertTemplates.find(template => template.id === site.alert_in_progress);

  const alertInProgress = site.alert_in_progress;
  const alertTemplate = alertInProgress ? alertTemplates.find(template => template.id === alertInProgress) : null;
  const alertStyle = alertTemplate
    ? { backgroundColor: alertTemplate.background_color || '#f0f0f0', color: '#fff' }
    : { backgroundColor: '#f3f3f3', color: '#000' };

    const handleSeeAllRequests = (requestTemplate, siteId) => {
      navigate(`/alert-requests`, { state: { siteId, requestTemplate } });
    };
    
  const handleClassroomDetails = (siteAlertInProgress, alertId) => {
    console.log('Viewing classroom details:', siteAlertInProgress, alertId)
    navigate('/classroom-details', { state: { alertTemplate, siteAlertInProgress, siteId: site.id, alertInProgressId: site.alert_in_progress_id } });
  };

  const handleTriggerAlert = async (alertTemplateId) => {
    console.log('Triggering alert:', site.id, alertTemplateId)
    try {
      await API.triggerAlert([site.id], alertTemplateId);
      setSuccess(<FormattedMessage id="ALERT_TRIGGER_SUCCESS" defaultMessage="Alert triggered successfully" />);
      refreshData();
    } catch (error) {
      console.error('Error triggering alert:', error);
      setError(<FormattedMessage id="ALERT_TRIGGER_ERROR" defaultMessage="Error triggering alert" />);
    }
  };

  const handleDismissAlert = async (alertTemplateId) => {
    console.log('Dismissing alert:', site.id, alertTemplateId);
    try {
      await API.dismissAlert(site.id, alertTemplateId);
      setSuccess(<FormattedMessage id="ALERT_DISMISS_SUCCESS" defaultMessage="Alert dismissed successfully" />);
      refreshData(); 
    } catch (error) {
      console.error('Error dismissing alert:', error);
      setError(<FormattedMessage id="ALERT_DISMISS_ERROR" defaultMessage="Error dismissing alert" />)
    }
  };

  return (
    <div className="card mb-3 site-card">
      <div className="card-header">
        <img className="siteCardIcon" src={MapPinIcon} alt="Map Pin" />
        {site.name}
      </div>
      <div className="card-body">
        {alertInProgress && alertTemplate ? (
          <div className="alert-request" style={alertStyle}>
            <div className="alert-info">
              <div className="alert-info-left">
                {alertTemplate.icon && <img src={alertTemplate.icon} className="alert-icon" alt={`${alertTemplate.name} icon`} />}
                <FormattedMessage id={alertTemplate.name.toUpperCase()} alt={alertTemplate.name} />
                &nbsp;<FormattedMessage id="ALERT_IN_PROGRESS" />
              </div>
              <div className="alert-buttons">
                <button id="classroomDetailsBtn" className="classroom-details-button" onClick={() => handleClassroomDetails(siteAlertInProgress, siteAlertInProgress.id)}>
                  <FormattedMessage id="CLASSROOM_DETAILS" />
                </button>
              </div>
            </div>
          </div>
        ) : Object.keys(site.consolidatedRequests).length > 0 ? (
          // Display consolidated requests keyed by alert template ID
          Object.keys(site.consolidatedRequests).map((alertTemplateId) => {
            const requests = site.consolidatedRequests[alertTemplateId];
            const requestTemplate = alertTemplates.find((t) => t.id === alertTemplateId);
            const requestStyle = { backgroundColor: '#f3f3f3', color: requestTemplate?.background_color || '#000' };

            return (
              <div key={alertTemplateId} className="alert-request" style={requestStyle}>
                <div className="alert-info">
                  <div className="alert-info-left">
                    {requestTemplate?.icon && <img src={requestTemplate.icon} className="alert-icon" alt={`${requestTemplate.name} icon`} />}
                    <span className="alert-type">{requestTemplate?.name}</span> 
                    &nbsp;<FormattedMessage id="ALERT_REQUESTS" /> ({requests.length})
                  </div>
                  <div className="alert-buttons">
                    <button id="triggerAlertBtn" className="trigger-alert-button" onClick={() => handleTriggerAlert(alertTemplateId)}>
                      <FormattedMessage id="TRIGGER_ALERT" />
                    </button>
                    <button id="dismissAlertBtn" className="dismiss-alert-button" onClick={() => handleDismissAlert(alertTemplateId)}>
                      <img src={DismissAlertIcon} alt="Dismiss Alert" className="dismiss-alert-icon" />
                    </button>
                  </div>
                </div>
                <div id="seeAllRequestsBtn" className="see-all-requests" onClick={() => handleSeeAllRequests(requestTemplate, site.id)}>
                  <FormattedMessage id="SEE_ALL_REQUESTS" />
                </div>
              </div>
            );
          })
        ) : (
          <div id="noAlertsMsg" className="alert-request no-alert">
            <FormattedMessage id="NO_ALERTS" defaultMessage="No alerts" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteCard;
